// src/components/ui/Input.js
import styled from 'styled-components';

const StyledInput = styled.input`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  font-size: 1rem;
  font-family: 'Roboto', sans-serif;
  border: none;
  outline: none;

  &:focus {
    border-color: ${(props) => props.theme.colors.primaryBlue};
  }
`;

export default function Input({
  type = 'text',
  disabled = false,
  placeholder,
  value,
  onChange = () => {},
  onKeyDown = () => {},
}) {
  return (
    <StyledInput
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onKeyDown={onKeyDown}
      onChange={(e) => {
        onChange(e.target.value);
      }}
    />
  );
}
